export default __webpack_public_path__ + "static/media/bg-experience.87ff559f.mp4";